module.exports = __webpack_public_path__ + "static/media/70.d1ec2d0.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/70.wav
// module id = I4P6
// module chunks = 0